import axiosClient from './axiosClient';

export default {
  // Ricerca paginata con filtri

  // Dettaglio singolo record logprocesso
  trova: (id) => axiosClient.get(`/richiestedemo/${id}`),
  list: (params) => axiosClient.get('/richiestedemo', { params }),
  create: (data) => axiosClient.post('/public/richiestademo', data),
  updateStatus: (id, body) => axiosClient.put(`/richiestedemo/${id}`, body),
  delete: (id) => axiosClient.delete(`/richiestedemo/${id}`),
};